import type { FeatureCollection } from 'geojson';

import { apiClient } from './apiClient';
import { normaliseFeatureCollectionResponse } from './geoJsonUtils';

/**
 * Fetches all DMAs for the given client from the backend.
 * Passes `clientId` as a query parameter so the ExternalAPI can scope the response
 * to the selected client rather than the caller's JWT claim client.
 * Returns a normalised GeoJSON FeatureCollection; never throws for invalid data.
 */
export async function fetchDmasForClient(clientId: string): Promise<FeatureCollection> {
    const response = await apiClient.get<unknown>('/dmas', { params: { clientId } });
    return normaliseFeatureCollectionResponse(response.data);
}

export async function fetchDmasForViewport(clientId: string, bbox: string): Promise<FeatureCollection> {
    const response = await apiClient.get<unknown>(`/dmas/md/${encodeURIComponent(bbox)}`, { params: { clientId } });
    return normaliseFeatureCollectionResponse(response.data);
}

export interface SearchDmaResult {
    ident: string;
    name: string;
    minLng: number;
    minLat: number;
    maxLng: number;
    maxLat: number;
}

export async function searchDmasForText(term: string, clientId: string): Promise<SearchDmaResult[]> {
    const response = await apiClient.get<SearchDmaResult[]>(`/dmas/search/${encodeURIComponent(term)}`, {
        params: { clientId },
    });
    return response.data;
}
